import { Link, useRoute } from "wouter";
import { trpc } from "@/lib/trpc";

export default function CmsPage() {
  const [, params] = useRoute("/strona/:slug");
  const slug = params?.slug ?? "";
  const page = trpc.cms.public.page.useQuery({ slug }, { enabled: Boolean(slug) });

  if (page.isLoading) {
    return <section className="bg-[#F8F8F6] px-4 py-28"><div className="mx-auto max-w-3xl text-[#1A2744]">Ładowanie podstrony...</div></section>;
  }

  if (!page.data) {
    return <section className="bg-[#F8F8F6] px-4 py-28"><div className="mx-auto max-w-3xl"><p className="mb-3 text-sm font-bold uppercase tracking-[0.12em] text-[#C41E1E]">Nie znaleziono strony</p><h1 className="mb-5 text-4xl font-extrabold uppercase text-[#0D0D0D]">Ta podstrona nie jest dostępna</h1><Link href="/" className="inline-flex bg-[#F5C400] px-5 py-3 text-sm font-extrabold uppercase tracking-[0.06em] text-[#111B30]">Wróć do strony głównej</Link></div></section>;
  }

  return (
    <article>
      <section className="bg-[#111B30] px-4 py-18 text-white sm:px-6 sm:py-24">
        <div className="mx-auto max-w-5xl"><p className="mb-3 text-xs font-bold uppercase tracking-[0.16em] text-[#F5C400]">PPHU Imperium</p><h1 className="max-w-3xl text-4xl font-extrabold uppercase leading-tight sm:text-6xl">{page.data.title}</h1></div>
      </section>
      <section className="bg-[#F8F8F6] px-4 py-12 sm:px-6 sm:py-18">
        <div className="mx-auto max-w-3xl whitespace-pre-line text-[1.05rem] leading-8 text-[#374151]">{page.data.content}</div>
      </section>
    </article>
  );
}
